<template>
    <div>
        <app-modal v-if="setModal" 
            modal-id="password-check-modal" 
            modal-alignment="center" modal-size="md" data-backdrop="static"
            data-keyboard="false">
            <div class="modal-body d-flex flex-column justify-content-center modal-alert">
                <div class="text-center">
                    <app-icon class="text-warning" :name="'alert-triangle'" />
                </div>
                <h5 class="text-center font-weight-bold mt-4">{{ $t('alert') + '!' }}</h5>
                <p class="text-center mb-4 font-size-90">{{ $t('Please enter password for verfication') }}</p>
                <app-input type="password" v-model="inputs.password" placeholder="Enter Password" />
                <small v-html="message" class="text-danger ml-2"></small>

                <div class="text-center mt-3">
                    <a href="#" class="btn btn-warning" @click="submit">
                        {{ $t('continue') }}
                    </a>
                </div>
            </div>
        </app-modal>

        <form-preview v-if="formPreview"
            :data="parameters" 
            :id="parameters.id" 
            :userId="parameters.user_id" 
            :form_id="parameters.form_id"
            :form_revision_id="parameters.form_revision_id" 
            :response="parameters.type">
        </form-preview>
    </div>
</template>

<script>
import GlobalHelperMixin from "../../../../Mixins/global/GlobalHelperMixin";
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import * as actions from "../../../../Config/ApiUrl";
import {axiosPost} from "@/app/Helpers/AxiosHelper";


export default {
    name: "CheckPasswordFormLink",
    mixins: [FormMixin, GlobalHelperMixin],
    props: {
        link: { type: [String, Number], required: true },
    },
    data() {
        return {
            formPreview: false,
            preloader: false,
            setModal: true,
            message: '',
            inputs: {},
            parameters: {},
        }
    },
    methods: {
        submit() {
            if (this.inputs.password == null) {
                this.message = 'Password Field Is Required';
            }
            else {
                this.inputs.link = this.link;

                axiosPost(actions.CHECK_PUBLIC_FORM_PASSWORD, this.inputs)
                    .then(res => {
                        if (res.data.status == 'success') {
                            $('#password-check-modal').modal('hide');
                            this.setModal = false;

                            this.parameters = res.data.data;
                            this.formPreview = true;
                        }
                        else {
                            this.message = res.data.message;
                        }
                    })
                    .catch(res => {
                        console.log(res);
                        // this.$toastr.e(res.data);
                    });
                }
            }
        },
    }
</script>
